export default __webpack_public_path__ + "static/media/hht1_ep03_timeline_09.78e7309d.png";